/**
 * How a keyboard shortcut is written for this computer: "⌘K" on a Mac,
 * "Ctrl+K" elsewhere.
 */
export function shortcutLabel(key: string): string {
    const isMac = typeof navigator !== 'undefined' && /Mac/i.test(navigator.platform);
    return isMac ? `⌘${key}` : `Ctrl+${key}`;
}
